module.exports = {
	"id": "PA",
	"name": "Panama",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02182,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.016365,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.016365,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01091,
			"27": null,
			"28": 0.005455,
			"29": 0.114555,
			"30": null,
			"31": 0.027275,
			"32": 0.005455,
			"33": 0.01091,
			"34": 0.02182,
			"35": 0.038185,
			"36": 0.027275,
			"37": 0.027275,
			"38": 0.05455,
			"39": 0.04364,
			"40": 0.027275,
			"41": 0.016365,
			"42": 0.016365,
			"43": 0.08728,
			"44": 0.049095,
			"45": 0.070915,
			"46": 0.06546,
			"47": 0.070915,
			"48": 0.092735,
			"49": 1.641955,
			"50": 0.14183,
			"51": 0.5455,
			"52": 0.49095,
			"53": 24.91844,
			"54": 6.51327,
			"55": 0.05455,
			"56": 0.016365,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.005455,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.02182,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.005455,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005455,
			"30": 0.01091,
			"31": 0.005455,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.005455,
			"36": 0.01091,
			"37": 0.01091,
			"38": 0.03273,
			"39": 0.038185,
			"40": 0.016365,
			"41": 0.02182,
			"42": 0.016365,
			"43": 0.12001,
			"44": 0.02182,
			"45": 0.08728,
			"46": 0.049095,
			"47": 0.267295,
			"48": 0.430945,
			"49": 3.7094,
			"50": 0.03273,
			"51": null,
			"52": null,
			"3.5": 0.02182,
			"3.6": 0.01091
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.027275,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.005455,
			"37": 0.049095,
			"38": 0.038185,
			"39": 0.01091,
			"40": 0.29457,
			"41": 0.038185,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01091
		},
		"safari": {
			"0": null,
			"4": 0.005455,
			"5": 0.038185,
			"6": 0.01091,
			"7": 0.03273,
			"8": 0.343665,
			"9": 0.420035,
			"10": 1.95289,
			"3.1": null,
			"3.2": null,
			"5.1": 0.08728,
			"6.1": 0.070915,
			"7.1": 0.027275,
			"9.1": 1.50558
		},
		"ios_saf": {
			"8": 0,
			"10": 3.13180396336,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0843984929226,
			"8.1-8.4": 0.155922639467,
			"9.0-9.2": 0.0743851124063,
			"9.3": 1.13484979184
		},
		"android": {
			"3": 0,
			"4": 0.11879244186,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0148490552326,
			"4.1": 0.42850130814,
			"4.2-4.3": 1.07125327035,
			"4.4": 2.45645799419,
			"4.4.3-4.4.4": 2.47767093023
		},
		"ie": {
			"6": null,
			"7": 0.00549070026178,
			"8": 0.356895517016,
			"9": 0.24708151178,
			"10": 0.236100111257,
			"11": 3.31089225785,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0724035364178,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00201120934494
		},
		"edge": {
			"12": 0.136375,
			"13": 0.55641,
			"14": 1.107365
		},
		"ie_mob": {
			"10": 0.0277821126761,
			"11": 0.113112887324
		},
		"bb": {
			"7": 0.031815,
			"10": null
		},
		"samsung": {
			"0": 8.26281
		},
		"and_uc": {
			"0": 0.26361
		},
		"op_mini": {
			"0": 0.975480254237
		},
		"and_chr": {
			"0": 26.970515
		},
		"and_ff": {
			"0": 0.022725
		}
	},
	"total": 99.0369800982
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PA.json
 ** module id = 617
 ** module chunks = 0
 **/